/**
 *
 * ProfileLeader
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"
import { Link } from "react-router-dom"

import Layout from "components/Layout"
import UserList from "components/UserList"
import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import iconPhone from "images/icon_phone.svg"
import iconMessage from "images/icon_message.svg"
import iconBirthday from "images/icon_birthday.svg"
import { Spin } from "antd"
import UserImage from "components/UserImage"
import saga from "./saga"
import { getPlansWatcher, updatePhotoWatcher } from "./actions"
import {
  makeSelectLoadingPlans,
  makeSelectLeader,
  makeSelectTeamLeader,
  makeSelectLoadingPhoto,
} from "./selectors"
import reducer from "./reducer"
import "./index.less"
import { loadTexts } from "../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
export class ProfileLeader extends React.Component {
  intlProfileLeader = loadTexts("my_profile").profileLeader
  id = parseInt(this.props.match.params.id)
  state = {
    paginationCurrentPage: 1,
    paginationPageSize: 15,
    modalActionPlanCreate: false,
    modalActionPlanEditId: null,
    selectedOrder: null,
    canCreate: false,
    isFilter: false,
    modalArchivePlan: false,
    modalArchiveLoading: false,
    currentPlan: {},
    measuresModalCreate: [],
  }

  componentDidUpdate() {
    if (this.id !== parseInt(this.props.match.params.id)) {
      this.id = parseInt(this.props.match.params.id)
      this.getProfile()
    }
  }

  componentDidMount() {
    this.getProfile()
  }

  getProfile = () => {
    this.props.getPlans({
      id_employee: this.id,
      type_active_plan: this.state.selectedOrder,
    })
  }

  render() {
    const { plans_loading, leader, team_leader } = this.props

    if (leader.id_employee !== this.id) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }

    return (
      <Layout>
        <Helmet>
          <title>{this.intlProfileLeader.titlePage}</title>
          <meta name="description" content="Description of Leader" />
        </Helmet>
        <div className="ProfileLeader" style={{ marginBottom: 60 }}>
          {queryString(this.props.location.search).rd == "organization" && (
            <Link
              to="/organization#collaborators"
              style={{ marginTop: "-20px", width: 60 }}>
              &lt; Perfil
            </Link>
          )}

          <div className="ProfileLeader-left">
            <div className="ProfileLeader-left-header">
              <div className="ProfileLeader-left-header-avatar">
                <Spin size="large" spinning={this.props.loading_photo}>
                  <UserImage
                    isAmbassador
                    url={leader.profile_picture}
                    setFile={(f) => {
                      const fd = new FormData()
                      fd.append("id", this.props.leader.id_employee)
                      if (f) {
                        fd.append("uploaded_file", f)
                      }
                      fd.append("delete_photo", !f)
                      this.props.updatePhoto(fd)
                    }}
                  />
                </Spin>
              </div>
              <div className="ProfileLeader-left-header-separator" />
              <div className="ProfileLeader-left-header-content">
                <div className="ProfileLeader-left-header-content-title">
                  <div className="string_dots">
                    <b>
                      {`${leader.first_name || ""} ${leader.last_name || ""}`}{" "}
                    </b>{" "}
                    -{" "}
                    <span
                      className="color-gray-low"
                      style={{ fontWeight: "normal" }}>
                      {" "}
                      {leader.position_name || ""}
                    </span>
                  </div>
                </div>
                <div
                  className="ProfileLeader-left-header-content-variables"
                  style={{ marginTop: 30 }}>
                  {leader.phone && (
                    <div className="string_dots">
                      <img src={iconPhone} />
                      {leader.phone || "-"}
                    </div>
                  )}
                  <div className="string_dots">
                    <b>{this.intlProfileLeader.timeInCompany}</b>{" "}
                    {leader.date_admission_2 || "-"}
                  </div>
                  <div className="string_dots">
                    <img src={iconMessage} />
                    {leader.email || "-"}
                  </div>
                  <div className="string_dots">
                    <img src={iconBirthday} />
                    {leader.date_birth_2 || "-"}
                  </div>
                </div>
              </div>
            </div>

            <div className="">
              {team_leader.length > 0 && (
                <UserList
                  styleContainer={{ width: 350 }}
                  hideLine
                  className="Dashboard-columns-right-team"
                  title={
                    <>
                      {this.intlProfileLeader.team} <span>({team_leader.length})</span>
                    </>
                  }
                  list={team_leader}
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  plans_loading: makeSelectLoadingPlans(),
  leader: makeSelectLeader(),
  team_leader: makeSelectTeamLeader(),
  loading_photo: makeSelectLoadingPhoto(),
})

function mapDispatchToProps(dispatch) {
  return {
    getPlans: (params) => dispatch(getPlansWatcher(params)),
    updatePhoto: (params) => dispatch(updatePhotoWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "profileLeader", reducer })
const withSaga = injectSaga({ key: "profileLeader", saga })

export default compose(withReducer, withSaga, withConnect)(ProfileLeader)
